import api from 'api'

const messageReader = async () => {
  const {
    data: { messages },
  } = await api.get(`/home/messages`)
  return messages
}

export default messageReader
